import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import ProfileModal from '../Profile/ProfileModal';

const getInitials = (name) => {
  if (!name) return '?';
  return name.trim().split(/\s+/).map(w => w[0]).join('').toUpperCase().slice(0, 2);
};

const APPS = [
  {
    id: 'budget',
    name: 'Budget Gestion',
    description: 'Suivi de vos finances personnelles',
    path: '/gestion-budget/dashboard',
    color: 'oklch(63% 0.19 278)',
    icon: (
      <svg width="36" height="36" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
        <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
        <polyline points="9 22 9 12 15 12 15 22"/>
      </svg>
    ),
  },
  {
    id: 'winamax',
    name: 'Gestion Winamax',
    description: 'Suivi de vos paris sportifs',
    path: '/gestion-bet/home',
    color: '#F97316',
    icon: (
      <svg width="36" height="36" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
      </svg>
    ),
  },
];

const LauncherPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [showProfile, setShowProfile] = useState(false);

  const joinDate = user?.createdAt
    ? new Date(user.createdAt).toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' })
    : '';

  return (
    <div className="launcher-root">
      <div className="profile-strip" onClick={() => setShowProfile(true)} title="Modifier mon profil">
        <div className="profile-avatar-lg">{getInitials(user?.name)}</div>
        <div className="profile-info">
          <div className="profile-name">{user?.name}</div>
          <div className="profile-meta">
            <span>{user?.email}</span>
            {joinDate && <><span className="dot">·</span><span>Membre depuis le {joinDate}</span></>}
          </div>
        </div>
      </div>

      <div className="launcher-header">
        <h1 className="launcher-title">Mes Applications</h1>
        <p className="launcher-sub">Choisissez une application pour continuer</p>
      </div>
      <div className="launcher-grid">
        {APPS.map(app => (
          <button
            key={app.id}
            className="launcher-card"
            style={{ '--app-color': app.color }}
            onClick={() => navigate(app.path)}
          >
            <div className="launcher-card-icon">{app.icon}</div>
            <div className="launcher-card-name">{app.name}</div>
            <div className="launcher-card-desc">{app.description}</div>
          </button>
        ))}
      </div>

      {showProfile && <ProfileModal onClose={() => setShowProfile(false)} />}
    </div>
  );
};

export default LauncherPage;
